import { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { useQueryClient } from '@tanstack/react-query';
import { useFetchCurrencies } from './useFetchCurrencies';

export const useCurrencySelection = () => {
  const [searchValue, setSearchValue] = useState<string>('');
  const queryClient = useQueryClient();

  const {
    data: currencyList,
    isLoading: isCurrenciesLoading,
    isFetching,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  } = useFetchCurrencies({
    pageSize: 100,
    search: searchValue,
  });

  const refreshCurrencyList = () => {
    queryClient.removeQueries({ queryKey: ['currencies'] });
    return refetch();
  };

  const { ref, inView } = useInView({
    threshold: 0.5,
  });

  useEffect(() => {
    if (inView && hasNextPage && !isFetchingNextPage && currencyList?.length > 0) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, isFetchingNextPage, currencyList]);

  return {
    currencyList,
    isCurrenciesLoading,
    isFetching,
    searchValue,
    setSearchValue,
    paginationRef: ref,
    hasNextPage,
    refreshCurrencyList,
  };
};
